import { Router } from '@angular/router';
import { BLoginService } from '../../service/bLogin.service';
var logingaurdService = (function () {
    function logingaurdService(bLoginService, router) {
        this.bLoginService = bLoginService;
        this.router = router;
    }
    logingaurdService.prototype.canActivate = function () {
        if (!this.bLoginService.isLoggedIn()) {
            return true;
        }
        else {
            this.router.navigate(['/bhive']);
            return false;
        }
    };
    return logingaurdService;
}());
export { logingaurdService };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/services/loginGaurd/logingaurd.service.ts.pre-build-optimizer.js